import { apiBaseURL, countryType, toastifyType } from "../../constant";
import { setLoading } from "./loadingAction";
import apiConfig from '../../config/apiConfig';
import { addTost } from "./toastAction";

export const countryAction = () => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await apiConfig.get(apiBaseURL.COUNTRIES);
    dispatch({ type: countryType.FETCH_COUNTRIES, payload: response.data.data });
    dispatch(setLoading(false));
  } catch (error) {
    dispatch(setLoading(false));
    dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }));
  }
};
